<div class="chart-display-section">
  <div class="chart-plotter-container" id="chart-container">
    <nz-spin
      nzTip="Crunching numbers..."
      *ngIf="chartFilters && !chartFilters.chartId"
      class="spinner"
    >
    </nz-spin>
    <app-chart-plotter
      *ngIf="chartFilters && chartFilters.chartId"
      [chartType]="selectedChart"
      [dataToUse]="dataToUse"
      (chartDataSet)="chartDataSet()"
      (onChartInstance)="onChartInstanceChange($event)"
    ></app-chart-plotter>
  </div>

  <div
    class="chart-info"
    class="chart-info"
    *ngIf="chartInfoBottom !== '0px'"
    [ngStyle]="{ bottom: chartInfoBottom }"
  >
    <div
      class="checkbox-sm"
      *ngIf="
        dataToUse &&
        dataToUse.lines.length > 1 &&
        !isSecondaryAxisUpdateInProgress
      "
    >
      <label
        nz-checkbox
        [(ngModel)]="isSecondaryAxis"
        (ngModelChange)="changeAxis($event)"
        class="checkbox-label"
        [nzDisabled]="!allowCombineAxis"
        >Secondary axis</label
      >
    </div>
    <div
      style="margin-left: 5px"
      *ngIf="dataToUse.chartTypeId === '3' && !isSecondaryAxisUpdateInProgress"
    >
      <span class="earnings-color"></span><span class="earnings">Earnings</span>
    </div>
  </div>
</div>
